import { render, staticRenderFns } from "./SubmerchantsList.vue?vue&type=template&id=6efb1864&"
import script from "./SubmerchantsList.vue?vue&type=script&lang=js&"
export * from "./SubmerchantsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports